(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["attractive-related-products"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('attractive-related-carousel')){
customElements.define('attractive-related-carousel',class extends HTMLElement{
connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';const track=this.querySelector('.apa-related__track');const cards=[...track.querySelectorAll('.apa-related__card')];const dots=this.querySelector('.apa-related__dots');const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;const step=()=>cards[0]?.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)||1;cards.forEach((card,index)=>{const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label','المنتج '+(index+1));dot.addEventListener('click',()=>track.scrollTo({left:index*step(),behavior:reduce?'instant':'smooth'}));dots.append(dot);});const update=()=>{const index=Math.round(track.scrollLeft/step());[...dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',i===index?'true':'false'));};this.addEventListener('click',event=>{const button=event.target.closest('[data-move]');if(!button)return;const max=track.scrollWidth-track.clientWidth;const direction=Number(button.dataset.move);let next=track.scrollLeft+direction*step();if(next>max+1)next=0;if(next<0)next=max;track.scrollTo({left:next,behavior:reduce?'instant':'smooth'});});track.addEventListener('scroll',update,{passive:true});update();}
});
}
  } catch(e) { console.error(e); }
})();

})();
